import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-values-product-configuration',
  templateUrl: './list-values-product-configuration.component.html',
  styleUrls: ['./list-values-product-configuration.component.scss']
})
export class ListValuesProductConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
